import { render, staticRenderFns } from "./EditAccountModal.vue?vue&type=template&id=18bd9f93"
import script from "./EditAccountModal.vue?vue&type=script&lang=js"
export * from "./EditAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports